import type { AnatomyBinding, AnatomySize } from "./componentAnatomy";
import { anatomyTextStyle } from "./componentAnatomyText";

// Mined from the three @include size(...) calls in TextArea.module.scss.
// Figma measures padding to the outer edge with the stroke inside, so the
// 1px border is subtracted; one row renders 28 / 32 / 40px.

const strokeInsideNote =
    "Figma measures padding to the outer edge with the stroke inside, so the 1px border is subtracted; one row renders 28 / 32 / 40px";

const geometry = ({
    paddingX,
    paddingBlock,
}: {
    paddingX: `--${string}`;
    paddingBlock: string;
}): readonly AnatomyBinding[] => [
    {
        partId: "background",
        property: "padding-inline",
        token: paddingX,
        via: "--textarea-padding-x",
    },
    {
        partId: "background",
        property: "padding-block",
        literal: paddingBlock,
        note: strokeInsideNote,
    },
];

const sTextBindings = anatomyTextStyle({
    scale: "s",
    weight: "400",
    mixin: "text-s-14-regular",
});

export const textAreaSizes: readonly AnatomySize[] = [
    {
        id: "md",
        label: "md · 28",
        selector: ".md",
        bindings: [
            ...geometry({
                paddingX: "--space-8",
                paddingBlock: "calc(var(--space-4) - var(--border-width))",
            }),
            ...sTextBindings,
        ],
    },
    {
        id: "lg",
        label: "lg · 32",
        selector: ".lg",
        bindings: [
            ...geometry({
                paddingX: "--space-12",
                paddingBlock: "calc(var(--space-6) - var(--border-width))",
            }),
            ...sTextBindings,
        ],
    },
    {
        id: "xl",
        label: "xl · 40",
        selector: ".xl",
        bindings: [
            ...geometry({
                paddingX: "--space-12",
                paddingBlock: "calc(var(--space-10) - var(--border-width))",
            }),
            ...sTextBindings,
        ],
    },
];
